// Generated by Melange

import ArtistCardModuleCss from "./artistCard.module.css";
import * as ReactRouter from "@tanstack/react-router";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Router__Link from "../router/link.jsx";
import * as Shared__CoverArt from "./coverArt.jsx";
import * as Shared__Skeleton from "./skeleton.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Store__Context from "../store/context.jsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = ArtistCardModuleCss;

function ArtistCard(Props) {
  let coverArtSizes = Props.coverArtSizes;
  let id = Props.id;
  let loadCoverArtLazily = Props.loadCoverArtLazily;
  const className = css.root;
  const artist = Store__Context.useAppStore(function (state) {
    return Stdlib__Option.bind(id, (function (id) {
      return Caml_option.undefined_to_opt(state.artists.byId.get(id));
    }));
  });
  let tmp = {};
  const tmp$1 = Stdlib__Option.map((function (x) {
    return x.coverArt;
  }), artist);
  if (tmp$1 !== undefined) {
    tmp.coverArt = Caml_option.valFromOption(tmp$1);
  }
  if (loadCoverArtLazily !== undefined) {
    tmp.lazy = Caml_option.valFromOption(loadCoverArtLazily);
  }
  if (coverArtSizes !== undefined) {
    tmp.sizes = Caml_option.valFromOption(coverArtSizes);
  }
  const children = JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(Shared__CoverArt.make, tmp),
      JsxRuntime.jsx("h2", {
        children: artist !== undefined ? artist.name : JsxRuntime.jsx(Shared__Skeleton.make, {
            style: {
              width: "6rem"
            }
          }),
        className: css.name
      })
    ]
  });
  if (artist !== undefined) {
    return JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, Caml_option.some(children), className, undefined, undefined, {
      artistId: artist.id
    }, undefined, "/artist/$artistId", undefined));
  } else {
    return JsxRuntime.jsx("span", {
      children: children,
      className: className
    });
  }
}

const make = ArtistCard;

export {
  make,
}
/* css Not a pure module */
